<template>
  <v-row align="center" justify="center">
    <v-dialog v-model="dialogVisible" persistent max-width="420">
      <v-card
        class="pa-4"
      >
        <v-container fluid>
          <v-row justify="center" align-content="center">
            <v-progress-circular
              :size="170"
              :width="7"
              color="primary"
              :value="(timerCount / $store.state.remoteConfig.authorizationTimeoutSecs) *100"
            >
              <span class="black--text text--primary"> {{ $t('dialog.request.timeLeft') }}: {{ minutesAndSeconds }}</span>
            </v-progress-circular>
            <!-- TODO: megcsinalni rendesen figma szerint es szopni az animationokkel + "Szellemképes" -->
          </v-row>
          <v-row justify="center" align-content="center">
            <div class="text-center mt-6 ma-2">
              {{ $t('dialog.request.requestAuthorization') }}
            </div>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      timerCount: this.$store.state.remoteConfig.authorizationTimeoutSecs,
      timerInterval: null
    }
  },
  computed: {
    minutesAndSeconds() {
      const minutes = Math.floor(this.timerCount / 60)
      const seconds = this.timerCount - minutes * 60
      return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`
    }
  },
  watch: {
    visible: function(newVal) {
      this.dialogVisible = newVal
      if (newVal) {
        this.startTimer()
      } else {
        this.stopTimer()
      }
    },
    dialogVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  beforeDestroy() {
    this.stopTimer()
  },
  methods: {
    startTimer() {
      this.timerCount = this.$store.state.remoteConfig.authorizationTimeoutSecs
      const end = Date.now() + this.$store.state.remoteConfig.authorizationTimeoutSecs * 1000
      this.timerInterval = setInterval(() => {
        const timeLeft = Math.floor((end - Date.now()) / 1000)

        if (timeLeft < 0) {
          clearInterval(this.timerInterval)
        } else {
          this.timerCount = timeLeft
        }
      }, 1000)
    },
    stopTimer() {
      clearInterval(this.timerInterval)
    }
  }
}
</script>

<style scoped>
.sic-modal-btn{
  position: relative;
  left: 90%;
  top: 10%;
}
</style>
